<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    header="Перевыгрузить выбранные займы"
    :modal="true"
    :style="{ width: '560px' }"
    :dismissable-mask="!submitting"
    :closable="!submitting"
  >
    <div class="field mb-3">
      <p class="mb-2"><strong>Выбрано займов:</strong> {{ selected.length }}</p>
      <p v-if="skippedCount > 0" class="text-orange-600">
        <i class="pi pi-exclamation-triangle"></i>
        У {{ skippedCount }} записей нет ЦБ УИД — они будут пропущены.
      </p>
    </div>

    <div class="field mb-3">
      <label class="block mb-2"><strong>Выберите бюро</strong></label>
      <div class="flex flex-wrap gap-3">
        <div v-for="bureau in bureausOptions" :key="bureau.value" class="flex align-items-center">
          <Checkbox v-model="selectedBureaus" :inputId="`bureau_${bureau.value}`" :value="bureau.value" />
          <label :for="`bureau_${bureau.value}`" class="ml-2">{{ bureau.label }}</label>
        </div>
      </div>
    </div>

    <div class="field mb-2">
      <label for="fromDate" class="block mb-2"><strong>Дата, с которой начинается перевыгрузка</strong></label>
      <Calendar
        id="fromDate"
        v-model="fromDate"
        dateFormat="dd.mm.yy"
        :showIcon="true"
        placeholder="Выберите дату (необязательно)"
        style="max-width: 300px"
      />
      <small class="block mt-2 p-text-secondary">
        Дата необязательна — если не указана, перевыгрузка пойдёт за всё время.
      </small>
    </div>

    <template #footer>
      <Button
        label="Отмена"
        icon="pi pi-times"
        class="p-button-text"
        :disabled="submitting"
        @click="$emit('update:visible', false)"
      />
      <Button
        label="Перевыгрузить"
        icon="pi pi-pencil"
        class="p-button-primary"
        :loading="submitting"
        @click="submit"
      />
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import LoanService from "@/service/LoanService";
import ResponseService from "@/service/ResponseService";
import { checkSendStops } from "@/helpers/sendStops";

export default {
  name: "LoanHistoryResendDialog",
  components: { Dialog, Checkbox },
  props: {
    visible: { type: Boolean, default: false },
    selected: { type: Array, default: () => [] },
  },
  emits: ['update:visible', 'done'],
  data() {
    return {
      submitting: false,
      fromDate: null,
      selectedBureaus: ['nbki', 'equ'],
      bureausOptions: [
        { label: 'НБКИ', value: 'nbki' },
        { label: 'Эквифакс', value: 'equ' },
      ],
    }
  },
  computed: {
    cbUuids() {
      return this.selected.map(r => r.cbUuid).filter(Boolean);
    },
    skippedCount() {
      return this.selected.length - this.cbUuids.length;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.fromDate = null;
        this.selectedBureaus = ['nbki', 'equ'];
      }
    }
  },
  methods: {
    formatDateToMSK(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}T00:00:00+03:00`;
    },
    submit() {
      if (this.selectedBureaus.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Не выбрано ни одно бюро',
          detail: 'Выберите хотя бы одно бюро для перевыгрузки.',
          life: 3000,
        });
        return;
      }
      if (this.cbUuids.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Нет ЦБ УИД для перевыгрузки',
          detail: 'У выбранных записей отсутствует ЦБ УИД.',
          life: 4000,
        });
        return;
      }

      this.submitting = true;

      checkSendStops(this.cbUuids, 'cbUuid', this.$confirm, this.$toast).then((subjects) => {
        if (subjects === null) {
          return;
        }

        return this.sendResend(subjects);
      }).catch((err) => {
        ResponseService.handleErrorResponseWithoutForm(err, this.$toast);
      }).finally(() => {
        this.submitting = false;
      });
    },
    sendResend(subjects) {
      const formattedDate = this.fromDate ? this.formatDateToMSK(this.fromDate) : null;

      return LoanService.resendLoans(subjects, this.selectedBureaus, false, false, formattedDate, 'cbUuid').then((res) => {
        if (res.failed === null || res.failed === undefined) {
          this.$toast.add({
            severity: 'success',
            summary: 'Перевыгрузка успешно начата',
            detail: res.feedback,
            life: 3000,
          });
          this.$emit('done');
          this.$emit('update:visible', false);
          return;
        }
        this.$toast.add({
          severity: 'warn',
          summary: 'Ошибка создания отчётов на перевыгрузку:',
          detail: res.failed ? res.failed.join(',') : subjects.join(','),
          life: 15000,
        });
      });
    }
  }
}
</script>
